<template>
    <div>
        <div>
            <div class="dropdown">
                <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton6"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{  translate.add_subscription }}
                </button>
                <form class="dropdown-menu p-4" aria-labelledby="dropdownMenuButton6">
                    <div class="mb-3">
                        <div class="input-group">
                            <select class="form-select" name="type"
                                    v-model="addType"
                                    id="exampleFormControlSelect1">
                                <option value="free">{{ translate.free }}</option>
                                <option value="premium">{{ translate.premium }}</option>
                            </select>
                        </div>
                    </div>
                    <button class="btn btn-primary" @click.prevent="addSubscription()">{{ translate.add }}</button>
                </form>
            </div>
        </div>
        <div class="table-responsive mt-1" style="min-height: 400px;">
            <table class="table">
                <thead>
                <tr>
                    <th>{{ translate.id }}</th>
                    <th>{{ translate.activity }}</th>
                    <th>{{ translate.active_to }}</th>
                    <th>{{ translate.status }}</th>
                    <th>{{ translate.type_access }}</th>
                    <th>{{ translate.updated_at }}</th>
                    <th>{{ translate.created_at }}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <user-subscription-table-row
                    v-for="subscription in subscriptions"
                    :key="subscription.id"
                    :translate="translate.row"
                    :item="subscription"
                    :is-tester="isTester"
                />
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
export default {
    props: ['data', 'userId', 'isTester', 'translate'],
    data() {
        return {
            subscriptions: this.data,
            addType: false,
        }
    },
    methods: {
        addSubscription() {
            if (!this.addType) {
                return false;
            }

            let subscriptionUrl = this.isTester ? '/tester/subscriptions' : '/subscriptions';

            axios
                .post(subscriptionUrl, {'type': this.addType, 'user_id' : this.userId})
                .then(response => (this.subscriptions = response.data.data))

        }
    },
    mounted() {
    }
}
</script>
